import React from "react";
import classes from "./Page404.module.css";
import Button from "../UI/Button/Button";

const Page404 = (props) => {
  return (
    <div className={classes.Page404}>
      <h2 className={classes.Header}>OOPS! </h2>
      <p className={classes.Header}>We're sorry, Connection seems Lost.</p>
      <Button href="/" type="Primary">
        Home Page
      </Button>
    </div>
  );
};

export default Page404;
